import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import ImpersonateNotification from '@/components/CommonUI/ImpersonateNotification.vue'
import LoaderErrorBlock from '@/components/CommonUI/LoaderErrorBlock.vue'
import NavigationBar from '@/components/NavigationBar.vue'
import { useAdvanceStore } from '@/store'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore()
const { getAdvanceHistory } = useAdvanceStore()

const dashboardUrl = process.env.VUE_APP_DASHBOARD_URL || 'https://dashboard.dittomusic.com'

const isLoaded = ref(false)
const hasLoadingError = ref(false)

const isImpersonateMode = computed(() => store.getters.isImpersonateMode)

onMounted(async () => {
  try {
    await store.dispatch('getJwtUser')
  } catch {
    window.location.replace(`${dashboardUrl}/login`)
    return
  }

  try {
    await Promise.all([
      store.dispatch('getUserSubscription').catch(() => undefined),
      store.dispatch('getUserVerification'),
      store.dispatch('getUserProfile'),
      getAdvanceHistory(1),
    ])

    await store.dispatch('getUserCurrencyConversionRate')

    if (store.getters.isSubscriptionMissing) {
      await store.dispatch('getUserActiveReleases')
    }

    isLoaded.value = true
  } catch {
    hasLoadingError.value = true
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NavigationBar),
    (!isLoaded.value)
      ? (_openBlock(), _createBlock(LoaderErrorBlock, {
          key: 0,
          class: "row no-space justify-center",
          "error-title": hasLoadingError.value ? _ctx.$gettext('Oops! We couldn’t load this right now.') : '',
          "error-message": hasLoadingError.value ? _ctx.$gettext('Please refresh the page or try again later.') : ''
        }, null, 8, ["error-title", "error-message"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (isImpersonateMode.value)
            ? (_openBlock(), _createBlock(ImpersonateNotification, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(_component_router_view)
        ], 64))
  ]))
}
}

})